import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["dsf_name", "dsf_role", "dsf_mobile", "dsf_profile_url"]
const _hoisted_2 = ["dsf_title", "onNavigate"]
const _hoisted_3 = ["dsf_title", "dsf_selected", "dsf_id"]
const _hoisted_4 = ["disabled", "dsf_title", "onNavigate"]
const _hoisted_5 = ["disabled", "dsf_title", "onNavigate"]
const _hoisted_6 = ["dsf_title", "onNavigate"]

import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

import { CarrierVettingStatus } from '@sennder/carrier-profile-public-axios-client'

import { logout } from '@/store/logoutActions'
import { getStateData } from '@/store/getters'
import { i18n, languages } from '@/services/i18n'
import { translationProvider } from '@/services/translationProvider'
import { analytics } from '@/services/analyticsProvider'
import { ANALYTICS_EVENTS } from '@/services/analyticsEvents'
import carrierUserService from '@/services/carrierUserService'
import errorsHandler from '@/services/errors-handler'
import {
  getCurrentTenantPermission,
  TenantPermissions,
} from '@/services/tenant-permissions'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileMenu',
  props: {
  mobileMode: Boolean,
},
  emits: ['item-click'],
  setup(__props, { emit }) {





const router = useRouter()

const userPicture = computed(() => getStateData().profile?.picture || null)

const companyName = computed(() => getStateData().company?.name || '')

const userName = computed(() => getStateData().profile?.name || '')

const isTeamInvitesAvailable = ref(false)
const isCarrierUnVetted = ref(false)

onMounted(async () => {
  isTeamInvitesAvailable.value = await getCurrentTenantPermission(
    TenantPermissions.showProfileTeamTab,
    getStateData().featureFlags
  )
  isCarrierUnVetted.value =
    getStateData().cpsCarrier?.vetting_status === CarrierVettingStatus.Unvetted
})

const redirectToInviteTab = async () => {
  analytics.trackEvent(ANALYTICS_EVENTS.INVITE_TEAM_MEMBER)
  const route = {
    name: 'Profile',
    query: { page: 'team', inviteFormExpanded: 'true' },
  }
  await router.push(route)

  emit('item-click')
}

const redirectToProfile = async () => {
  analytics.trackEvent(ANALYTICS_EVENTS.MENU_COMPANY_PROFILE_CLICK)
  const route = {
    name: 'Profile',
    query: { page: 'rating' },
  }
  await router.push(route)

  emit('item-click')
}

async function onLanguageChange(evt: Event) {
  const { detail: language } = evt as CustomEvent<string>
  translationProvider.set(language, {
    updated: async () => {
      analytics.trackEvent(ANALYTICS_EVENTS.LANGUAGE_CHANGE)
      try {
        await carrierUserService.changeLanguage(language)
      } catch (error: any) {
        error.notification = {
          message: i18n.global.t('serverError.msg'),
        }
        errorsHandler(
          error,
          '[orcas-shell - Store]: Language choice can not be sent'
        )
      }
    },
  })

  emit('item-click')
}

let isLoggingOut = false

const onLogout = async () => {
  if (isLoggingOut) {
    return
  }
  analytics.trackEvent(ANALYTICS_EVENTS.MENU_LOGOUT_CLICK)
  isLoggingOut = true
  try {
    await logout({ callBackend: true, calledByUser: true })
  } finally {
    isLoggingOut = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dsf-nav-menu", {
    dsf_name: companyName.value,
    dsf_role: userName.value,
    dsf_mobile: __props.mobileMode,
    dsf_profile_url: userPicture.value
  }, [
    _createCommentVNode(" Language selector "),
    _createElementVNode("dsf-navbar-item", {
      dsf_light: "",
      dsf_icon: "Globe",
      dsf_title: _ctx.$t('sidebar.language'),
      dsf_id: "language",
      onNavigate: _withModifiers(onLanguageChange, ["stop"])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languages), (lang) => {
        return (_openBlock(), _createElementBlock("dsf-navbar-item", {
          key: lang.value,
          dsf_title: lang.label,
          dsf_selected: lang.value === _unref(translationProvider).currentLanguage,
          dsf_id: lang.value
        }, null, 8 /* PROPS */, _hoisted_3))
      }), 128 /* KEYED_FRAGMENT */))
    ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_2),
    _createCommentVNode(" Settings "),
    _createElementVNode("dsf-navbar-item", {
      disabled: isCarrierUnVetted.value,
      dsf_light: "",
      dsf_icon: "Settings",
      dsf_title: _ctx.$t('sidebar.usermenu.settings'),
      dsf_id: "settings",
      onNavigate: _withModifiers(redirectToProfile, ["stop"])
    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_4),
    _createCommentVNode(" Invite team members "),
    (isTeamInvitesAvailable.value)
      ? (_openBlock(), _createElementBlock("dsf-navbar-item", {
          key: 0,
          disabled: isCarrierUnVetted.value,
          dsf_light: "",
          dsf_icon: "Users",
          dsf_title: _ctx.$t('sidebar.usermenu.inviteTeamMember'),
          dsf_id: "invite",
          onNavigate: _withModifiers(redirectToInviteTab, ["stop"])
        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_5))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Logout "),
    _createElementVNode("dsf-navbar-item", {
      dsf_light: "",
      dsf_icon: "LogOut",
      dsf_title: _ctx.$t('sidebar.logout'),
      dsf_id: "logout",
      onNavigate: _withModifiers(onLogout, ["stop"])
    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_6)
  ], 8 /* PROPS */, _hoisted_1))
}
}

})